import React from 'react'
import { SVGIconProps } from '../types'
const SvgFiberManualRecord = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M24 24H0V0h24z" />
    <circle cx={12} cy={12} r={8} />
  </svg>
)
export default SvgFiberManualRecord
